import { styled, Grid, List, ListItem, Button, IconButton } from "@mui/material";
import theme from "@/shared/theme/theme";

export const SIDEBAR_WIDTH = {
  CLOSED: "90px",
  OPEN: "230px"
};

export const TOOLBAR_HEIGHT = "65px";

export const LayoutContainer = styled(Grid)({
  width: "100%",
  height: "auto",
  display: "flex"
});

export const MainContent = styled(Grid)(({ theme }) => ({
  width: `calc(100% - ${SIDEBAR_WIDTH.CLOSED})`,
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  transition: theme.transitions.create(["width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  "&.open": {
    width: `calc(100% - ${SIDEBAR_WIDTH.OPEN})`
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    "&.open": {
      width: `100%`
    }
  }
}));

export const ToolBarWrapper = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: TOOLBAR_HEIGHT,
  padding: "0 1rem",
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(["width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "50px"
  }
}));

export const SideBarWrapper = styled(Grid)(({ theme }) => ({
  width: SIDEBAR_WIDTH.CLOSED,
  backgroundColor: theme.palette.primary.main,
  height: "100vh",
  maxHeight: "100vh",
  overflow: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  "&.open": {
    width: SIDEBAR_WIDTH.OPEN
  },
  [theme.breakpoints.down("md")]: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 8000,
    width: "0vw",
    visibility: "hidden",
    transition: theme.transitions.create(["width", "visibility"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    "&.open": {
      visibility: "visible",
      width: "57vw"
    }
  }
}));

export const ContentWrapper = styled(Grid)({
  width: "100%",
  height: `calc(100% - ${TOOLBAR_HEIGHT})`,
  overflow: "hidden",
  overflowY: "auto",
  position: "relative",
  background: "var(--m-color-gray-01)"
});

export const ToggleSideBarButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 5,
  left: SIDEBAR_WIDTH.CLOSED,
  width: "50px",
  height: "50px",
  transform: "translateX(-60%)",
  svg: {
    marginLeft: "20px",
    color: theme.palette.primary.contrastText,
    width: "50px",
    height: "50px"
  },
  backgroundColor: theme.palette.primary.main,
  zIndex: 1004,
  borderRadius: "1000px",
  "&:hover": {
    backgroundColor: theme.palette.primary.main
  },
  transition: theme.transitions.create(["left"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  "&.open": {
    left: SIDEBAR_WIDTH.OPEN
  },
  [theme.breakpoints.down("md")]: {
    display: "none"
  }
}));

export const ContentRender = styled(Grid)({
  paddingTop: "1rem",
  "& .maxcore-ballow": {
    position: "relative",
    zIndex: 4000,
    display: "block",
    svg: {
      width: "45px",
      height: "45px"
    }
  },
  "& .maxcore-logo": {
    display: "none",
    position: "relative",
    zIndex: 1000,
    svg: {
      width: "150px",
      height: "30px"
    }
  },
  "&.open": {
    "& .toggle-side-bar-button": {
      left: SIDEBAR_WIDTH.OPEN,
      transform: "translateX(-60%)",
      transition: "all 0.2s ease-in-out",
      svg: {
        transform: "rotate(180deg)"
      }
    },
    "& .maxcore-ballow": {
      display: "none"
    },
    "& .maxcore-logo": {
      display: "block"
    },
    "& .MuiListItemIcon-root": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    "& .MuiListItemText-root": {
      display: "block",
      color: theme.palette.primary.contrastText,
      "& span": {
        fontSize: "12px",
        whiteSpace: "nowrap"
      }
    }
  }
});

export const ListRender = styled(List)(({ theme }) => ({
  svg: {
    width: "1.1rem",
    height: "1.1rem",
    color: theme.palette.primary.contrastText
  },
  "& .MuiListItemIcon-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  "& .MuiListItemText-root": {
    display: "none"
  }
}));

export const SideBarItem = styled(ListItem)(({ theme }) => ({
  cursor: "pointer",
  padding: theme.spacing(1.5),
  display: "flex",
  justifyItems: "center",
  alignItems: "center",
  "&:hover": {
    backgroundColor: theme.palette.error.main
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.main
    }
  }
}));
